import { CHANGE_TAB } from "../actions/tabAction";

const initialState = {
  initialTab: 0,
};

const tabReducer = (state = initialState, action) => {
  if (action.type === CHANGE_TAB) {
    return {
      ...state,
      initialTab: action.payload,
    };
  }

  return state;
};

export default tabReducer;
